export const externalScriptsOnInit = {
  FATHOM: {
    src: 'https://cdn.usefathom.com/script.js',
    attrs: {
      'data-site': 'ZQQVKPXI',
      defer: true,
    },
  },
};
